export const unifiedError = {
  // 内容策略相关
  content_policy: 'Content does not comply with platform policy, please modify and try again',
  safety_policy: 'Content does not comply with safety policy, please modify and try again',
  recitation: 'Content may involve copyright issues, please modify the prompt and try again',
  
  // 资源限制相关
  rate_limit: 'Too many requests, please try again later',
  credits: 'Insufficient credits, please subscribe to a plan or purchase credit packs',
  quota_exceeded: 'Usage quota limit reached, please try again later',
  
  // 生成相关
  no_image: 'Unable to generate image for this prompt, please try modifying the prompt',
  generation_failed: 'Generation failed, please try again',
  timeout: 'Processing timeout, please check history records later',
  
  // 网络和服务器相关
  network_error: 'Network connection failed, please check your network and try again',
  server_error: 'Server internal error, please try again later',
  auth_error: 'Authentication failed, please login again',
  not_found: 'Requested resource not found',
  
  // 输入验证相关
  invalid_input: 'Invalid input, please check and try again',
  missing_required: 'Please fill in required fields',
  
  // 未知错误
  unknown: 'Unknown error occurred, please try again',
  
  // 通用消息
  general: {
    operationFailed: 'Operation failed, please try again',
    tryAgainLater: 'Please try again later',
    contactSupport: 'If the problem persists, please contact support'
  }
};